import { styled } from "@mui/material";
import { Field, FormikProvider, FormikValues, useFormik } from "formik";
import Button from "../../../../customs/Button";
import Input from "../../../../customs/FormInput";
import Select from "../../../../customs/SelectInput";
import CustomTextArea from "../../../../customs/textarea";
import * as Yup from "yup";
import apiCall from "../../../../utils/apiCall";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";
import { NotificationContext } from "../../../../providers/notification";

interface IndustrySetUpData {
  Name: number;
  IndustrySetUpId: string;
}
interface CreateIndustryPayload {
  IndustryId:number;
  IndustrySector: string;
  IsActive: boolean;
  IndustryName:string;
}
interface ComponentProps {
  IndustryId: number;
  IndustrySector: string;
  IndustryName:string;
  IsActive?:boolean;
  handleClose: () => void;
}

const EditIndustryContent: React.FC<ComponentProps> = ({
  IndustryId,
  handleClose,
  IndustrySector,
  IsActive,
  IndustryName
}) => {
 
  const { showNotification } = useContext(NotificationContext);
  const queryClient = useQueryClient();
  const GetAllIndustrySetUps = async (): Promise<any> => {
    return await apiCall().get(`/SetUp/GetAllIndustrySetUps`);
  };

  const createIndustry = async (payload: CreateIndustryPayload) => {
    return await apiCall().post("/SetUp/CreateUpdateIndustry", payload);
  };

  const updateIndustryMutation = useMutation(["update-Industry"], createIndustry, {
    retry: 0,
  });

  const createIndustryHandler = async (
    values: FormikValues,
    resetForm: () => void
  ) => {
    const updateIndustryPayload: CreateIndustryPayload = {
        IndustryId:IndustryId,
      IndustrySector: values.IndustrySector,
      IsActive:IsActive || false ,
      IndustryName:values.IndustryName
    };

    try {
      await updateIndustryMutation.mutateAsync(updateIndustryPayload, {
        onSuccess: (data) => {
          
          showNotification({
            message: "Industry updated successful",
            type: "success",
          });
          queryClient.refetchQueries(["get-AllIndustry"]);
          handleClose();
        },
      });
    } catch (error: any) {
      showNotification({
        message: error?.response?.data?.Message || error?.message,
        type: "error",
      });
    }
  };

  const validationSchema = Yup.object().shape({
    IndustryName: Yup.string().required("Industry Name is required"),
    IndustrySector: Yup.string().required("Industry Sector is required"),

  });
  const formik = useFormik<FormikValues>({
    initialValues: {
      IndustryId: IndustryId ? IndustryId : "",
      IndustryName: IndustryName ? IndustryName : "",
      IndustrySector: IndustrySector ? IndustrySector : "",
      IsActive:IsActive?IsActive:false,
    },
    onSubmit: (values, { resetForm }) => {
      createIndustryHandler(values, resetForm);
    },
    validationSchema,
  });

  return (
    <FormikProvider value={formik}>
      <form onSubmit={formik.handleSubmit}>
        <FormWrapper>
          <Field
            name="IndustryName"
            type="text"
            as={Input}
            label="Industry Name"
            
            placeholder="Enter Industry Name"
          />
          <Field
            name="IndustrySector"
            type="text"
            as={Input}
            label="Industry Sectory"
            placeholder="Enter Industry Sector"
          />
          
        </FormWrapper>
        <ButtonWrapper>
          <ButtonContainer>
            <StyledButton text="Cancel" onClick={handleClose} />
            <StyledButton
              disabled={updateIndustryMutation.isLoading}
              text={updateIndustryMutation.isLoading ? "UPDATING" : "UPDATE"}
              onClick={formik.handleSubmit}
              type="button"
            />
          </ButtonContainer>
        </ButtonWrapper>
      </form>
    </FormikProvider>
  );
};

export default EditIndustryContent;

const FormWrapper = styled("div")`
  margin-inline: 3.5rem;
`;

const ButtonWrapper = styled("div")`
  display: flex;
  justify-content: flex-end;
  margin-block: 2.5rem;
  padding-inline: 3.5rem;
`;

const ButtonContainer = styled("div")`
  display: flex;
  gap: 2rem;
`;

const StyledButton = styled(Button)`
  padding-block: 1rem;
  padding-inline: 2rem;
`;
